import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root'); // This is important for accessibility reasons

const CharacteristicModal = ({ isOpen, onClose, onSubmit, initialName = '', initialType = '', initialLibcode = 0 }) => {
  const [name, setName] = useState(initialName);
  const [type, setType] = useState(initialType || '1');
  const [libraryOptions, setLibraryOptions] = useState([]);
  const [libField, setLibField] = useState(0);

  // Этот эффект нужен, чтобы сбрасывать или заполнять поля при каждом открытии модального окна
  useEffect(() => {
    setName(initialName);
    //setType(initialType || '1');
    handleType(initialType || '1');
  }, [initialName, initialType, isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ name, type, libField });
    onClose();
  };

  const handleType = (iType) => {
    setType(iType);
    if (iType == '4') {
      console.log("initialLibcode = " + initialLibcode);
      fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/selectAttachedLib`) // Замените на ваш API-адрес
        .then(response => response.json())
        .then(data => setLibraryOptions(data))
        .catch(error => console.error('Ошибка загрузки данных:', error));
        setLibField(initialLibcode);
    }
    else {
      setLibField(0);
    }
  };

  const customStyles = {
    content: {
      width: '400px',   // Ширина модального окна
      height: '300px',  // Высота модального окна
      margin: 'auto',   // Центрирование окна
      padding: '20px',  // Отступы внутри модального окна
      borderRadius: '10px', // Скругление углов
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.75)', // Прозрачный темный фон для overlay
    },
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} style={customStyles} contentLabel="Добавить характеристику">

      <h2>{initialName ? 'Редактировать характеристику' : 'Добавить характеристику'}</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Наименование:</label>
          <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />
        </div>
        <div>
          <label>Тип значения:</label>
          <select value={type} onChange={(e) => handleType(e.target.value)} required>
            <option value="1">Целочисленное</option>
            <option value="2">Дробное</option>
            <option value="0">Строковое</option>
            <option value="3">Дата</option>
            <option value="4">Из справочника</option>
          </select>
        </div>
        {type === '4' ? (
            <div><select
              value={libField}
              onChange={(e) => setLibField(e.target.value)}
              required
            >
              {libraryOptions.map((option, index) => (
                <option key={index} value={option.id}>
                  {option.name}
                </option>
              ))}
            </select></div>
          ): (<></>)}
        <button type="submit">Сохранить</button>
        <button type="button" onClick={onClose}>Отмена</button>
      </form>
    </Modal>
  );
};

export default CharacteristicModal;